import type { AxiosResponse } from 'axios';
import { z } from 'zod';

import HttpRepository from './httpRepository';

const configSchema = z.object({
	TRADESHIFT_GO_HOST: z.string(),
	PAYMENTS_EXTERNAL_HOST: z.string(),
	FINTECH_PAYMENTS_HOST: z.string(),
	VERSION: z.string(),
	ENVIROMENT: z.string(),
	IS_PRODUCTION: z.boolean(),
	IS_SANDBOX: z.boolean(),
	IS_DEMO: z.boolean(),
	SENTRY_PUBLIC_DSN: z.string(),
});

export const ConfigRepository = {
	get: <K extends keyof typeof configSchema.shape>(key: K): globalThis['config'][K] => {
		const value = globalThis.config[key];
		const partialSchema = z.object({ [key]: configSchema.shape[key] });
		const result = partialSchema.safeParse({ [key]: value });
		if (!result.success && !globalThis.IS_PLAYWRIGHT_RUNNING) {
			throw new Error('Validation failed');
		}

		if (result.success) {
			return result.data[key] as unknown as globalThis['config'][K];
		}

		return value as globalThis['config'][K];
	},
	getServerVersion: async () => {
		const response: AxiosResponse = await HttpRepository.tradeshiftGoFrontend().get('/rest/version');
		const result = z.string().safeParse(response.data);
		if (!result.success && !globalThis.IS_PLAYWRIGHT_RUNNING) {
			throw new Error('Validation failed');
		}

		return result.success ? result.data : response.data;
	},
	getProviderMappingConfigs: async () =>
		HttpRepository.tradeshiftGo()
			.get('/rest/providerMappingConfigs/')
			.then(response => response.data),
};
